export default __webpack_public_path__ + "static/carpass_black~exaHvQRk-848b5eb9257b60d75b458668e0d55e03.png";